import ReleaseThree from "../mockData/images/releases/3.jpg"
import ReleaseEight from "../mockData/images/releases/8.jpg"
import ReleaseNine from "../mockData/images/releases/9.jpg"
import ReleaseTen from "../mockData/images/releases/10.jpg"
import ReleaseTwelve from "../mockData/images/releases/12.jpg"
import { EARNINGS_STORE_NAMES, EARNINGS_STORE_WEIGHTS } from "./earningsStoreNames";

const countryCodes = ['AFG', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'CPV', 'KHM', 'CMR', 'CAN', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COD', 'COG', 'COK', 'CRI', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'CIV', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'SWZ', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'MKD', 'ROU', 'RUS', 'RWA', 'REU', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'UMI', 'USA', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE', 'ALA'];

const TOP_FIVE_TEMPLATE = {
    top_tracks: [
        { track_name: "Celestial Voyage Mix", track_revenue: "0 €" },
        { track_name: "Veil of the Vortex Mix", track_revenue: "0 €" },
        { track_name: "Dusk Horizon", track_revenue: "0 €" },
        { track_name: "Echoes of Eternity Remix", track_revenue: "0 €" },
        { track_name: "Whispering Willows Mix", track_revenue: "0 €" },
    ],
    top_releases: [
        { release_name: "Rising Silhouette", release_artwork: ReleaseEight, release_revenue: "0 €" },
        { release_name: "Melodic Harmony", release_artwork: ReleaseTen, release_revenue: "0 €" },
        { release_name: "Echoing Harmony", release_artwork: ReleaseNine, release_revenue: "0 €" },
        { release_name: "Whispering Rhapsody", release_artwork: ReleaseTwelve, release_revenue: "0 €" },
        { release_name: "Mystic Voyage", release_artwork: ReleaseThree, release_revenue: "0 €" },
    ],
    top_artists: [
        { artist_name: "Felix Lyric", revenue: "0 €" },
        { artist_name: "Aster Veldt", revenue: "0 €" },
    ],
};

const STORES_PERCENTAGES = (() => {
    const percentages = { ...EARNINGS_STORE_WEIGHTS };
    EARNINGS_STORE_NAMES.forEach(name => {
        if (percentages[name] === undefined) {
            percentages[name] = 0.35;
        }
    });
    return percentages;
})();

const STORES_RANKED_BY_WEIGHT = Object.keys(STORES_PERCENTAGES)
    .sort((a, b) => (STORES_PERCENTAGES[b] ?? 0) - (STORES_PERCENTAGES[a] ?? 0));

const hashFilterValue = value => {
    const text = String(value ?? "");
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
};

const isActiveFilter = value => value != null && String(value) !== "0";

const createSeededRandom = seed => {
    let state = (hashFilterValue(seed) % 233280) + 1;
    return () => {
        state = (state * 9301 + 49297) % 233280;
        return state / 233280;
    };
};

const roundCurrency = value => parseFloat(Number(value).toFixed(2));

const formatEuro = value => `${roundCurrency(value).toFixed(2)} €`;

/** Scale values so they sum exactly to targetSum (2 decimal places). */
const normalizeToSum = (values, targetSum) => {
    if (!values.length) {
        return [];
    }
    const safeTarget = roundCurrency(targetSum);
    const weights = values.map(value => Math.max(0, Number(value) || 0));
    const weightSum = weights.reduce((sum, value) => sum + value, 0) || 1;
    const scaled = weights.map(weight => (weight / weightSum) * safeTarget);
    const rounded = scaled.slice(0, -1).map(roundCurrency);
    const partial = rounded.reduce((sum, value) => sum + value, 0);
    rounded.push(roundCurrency(safeTarget - partial));
    return rounded;
};

const resolveFilterScale = (filters = {}) => {
    let scale = 1;
    if (isActiveFilter(filters.subuser)) {
        scale *= 0.45 + (hashFilterValue(filters.subuser) % 45) / 100;
    }
    if (isActiveFilter(filters.label)) {
        scale *= 0.55 + (hashFilterValue(filters.label) % 35) / 100;
    }
    if (isActiveFilter(filters.release)) {
        scale *= 0.35 + (hashFilterValue(filters.release) % 30) / 100;
    }
    if (isActiveFilter(filters.track)) {
        scale *= 0.25 + (hashFilterValue(filters.track) % 25) / 100;
    }
    if (isActiveFilter(filters.country)) {
        scale *= 0.4 + (hashFilterValue(filters.country) % 40) / 100;
    }
    if (isActiveFilter(filters.store)) {
        const storeWeight = STORES_PERCENTAGES[filters.store] ?? 1;
        const weightSum = Object.values(STORES_PERCENTAGES).reduce((sum, weight) => sum + weight, 0) || 1;
        scale *= Math.max(0.15, (storeWeight / weightSum) * 4);
    }
    return scale;
};

const buildReportSeed = (startingMonth, endingMonth, filters = {}) => [
    startingMonth.format("YYYY-MM"),
    endingMonth.format("YYYY-MM"),
    filters.store || "0",
    filters.label || "0",
    filters.release || "0",
    filters.track || "0",
    filters.country || "0",
    filters.subuser || "0",
].join("|");

const buildTotalEarnings = (filters, random) => {
    const base = 20 + random() * 180;
    return roundCurrency(base * resolveFilterScale(filters));
};

const buildStoreBreakdown = (totalEarnings, selectedStore, random) => {
    if (isActiveFilter(selectedStore)) {
        return [{ store: String(selectedStore), revenue: totalEarnings }];
    }

    const maxStoresInChart = 12;
    const selectedStoreCount = Math.min(
        STORES_RANKED_BY_WEIGHT.length,
        Math.floor(random() * Math.min(STORES_RANKED_BY_WEIGHT.length, maxStoresInChart)) + 1,
    );
    const selectedStores = STORES_RANKED_BY_WEIGHT.slice(0, selectedStoreCount);

    const weights = selectedStores.map(store => {
        const baseWeight = STORES_PERCENTAGES[store] ?? 0.35;
        const jitter = 0.92 + (random() * 0.16);
        return Math.max(0.01, baseWeight * jitter);
    });
    const revenues = normalizeToSum(weights, totalEarnings);

    return selectedStores
        .map((store, index) => ({ store, revenue: revenues[index] }))
        .filter(item => item.revenue > 0)
        .sort((a, b) => b.revenue - a.revenue);
};

const buildMonthSeries = (startingMonth, endingMonth) => {
    const months = [];
    const currentMonth = startingMonth.clone();
    while (currentMonth <= endingMonth) {
        months.push(currentMonth.format("MMM YYYY"));
        currentMonth.add(1, "month");
    }
    return months;
};

const buildMultiRevenueData = (months, totalEarnings, storeBreakdown, random) => {
    const monthWeights = Array.from({ length: months.length }, () => 0.5 + random());
    const monthTotals = normalizeToSum(monthWeights, totalEarnings);
    const storeNames = storeBreakdown.map(item => item.store);
    const storeWeights = storeBreakdown.map(item => item.revenue);
    const storesRevenue = storeNames.reduce((acc, store) => {
        acc[store] = new Array(months.length).fill(0);
        return acc;
    }, {});

    monthTotals.forEach((monthTotal, monthIndex) => {
        const storeMonthValues = normalizeToSum(storeWeights, monthTotal);
        storeNames.forEach((store, storeIndex) => {
            storesRevenue[store][monthIndex] = storeMonthValues[storeIndex];
        });
    });

    const combinedRevenue = months.map((_, monthIndex) =>
        roundCurrency(storeNames.reduce((sum, store) => sum + storesRevenue[store][monthIndex], 0)),
    );

    return {
        months,
        stores_revenue: storesRevenue,
        combined_revenue: combinedRevenue,
        revenue_sum: roundCurrency(combinedRevenue.reduce((sum, value) => sum + value, 0)),
    };
};

const buildStorewiseRevenue = storeBreakdown => ({
    store: storeBreakdown.map(item => item.store),
    revenue: storeBreakdown.map(item => parseFloat(item.revenue.toFixed(3))),
});

const buildCountrySales = (totalEarnings, countryCode, random) => {
    const selectedCountries = new Set();
    while (selectedCountries.size < 50) {
        selectedCountries.add(countryCodes[Math.floor(random() * countryCodes.length)]);
    }
    const selectedCountryArray = Array.from(selectedCountries);
    let countryWeights = selectedCountryArray.map(() => 0.2 + random());

    if (isActiveFilter(countryCode)) {
        const primaryIndex = selectedCountryArray.indexOf(countryCode);
        if (primaryIndex >= 0) {
            countryWeights[primaryIndex] = countryWeights[primaryIndex] * 4 + 2;
        } else {
            selectedCountryArray[0] = String(countryCode);
            countryWeights[0] = countryWeights[0] * 4 + 2;
        }
    }

    const countryValues = normalizeToSum(countryWeights, totalEarnings);
    const countryEarnings = selectedCountryArray.map((id, index) => ({
        id,
        value: countryValues[index],
    }));

    return {
        country_earnings: countryEarnings,
        max: countryEarnings.reduce((max, sale) => (sale.value > max ? sale.value : max), 0),
    };
};

const cloneTopFiveTemplate = () => ({
    top_tracks: TOP_FIVE_TEMPLATE.top_tracks.map(track => ({ ...track })),
    top_releases: TOP_FIVE_TEMPLATE.top_releases.map(release => ({ ...release })),
    top_artists: TOP_FIVE_TEMPLATE.top_artists.map(artist => ({ ...artist })),
});

const buildTopFive = (totalEarnings, random) => {
    const topFive = cloneTopFiveTemplate();
    const trackPool = roundCurrency(totalEarnings * 0.42);
    const releasePool = roundCurrency(totalEarnings * 0.38);
    const artistPool = roundCurrency(totalEarnings - trackPool - releasePool);

    const trackWeights = topFive.top_tracks.map(() => 0.4 + random());
    const releaseWeights = topFive.top_releases.map(() => 0.4 + random());
    const artistWeights = topFive.top_artists.map(() => 0.4 + random());

    const trackRevenues = normalizeToSum(trackWeights, trackPool);
    const releaseRevenues = normalizeToSum(releaseWeights, releasePool);
    const artistRevenues = normalizeToSum(artistWeights, artistPool);

    topFive.top_tracks.forEach((track, index) => {
        track.track_revenue = formatEuro(trackRevenues[index]);
    });
    topFive.top_tracks.sort((a, b) => parseFloat(b.track_revenue) - parseFloat(a.track_revenue));

    topFive.top_releases.forEach((release, index) => {
        release.release_revenue = formatEuro(releaseRevenues[index]);
    });
    topFive.top_releases.sort((a, b) => parseFloat(b.release_revenue) - parseFloat(a.release_revenue));

    topFive.top_artists.forEach((artist, index) => {
        artist.revenue = formatEuro(artistRevenues[index]);
    });
    topFive.top_artists.sort((a, b) => parseFloat(b.revenue) - parseFloat(a.revenue));

    return topFive;
};

const simulateMockEarningsData = (startingMonth, endingMonth, filters = {}) => {
    const selectedStore = isActiveFilter(filters.store) ? String(filters.store) : null;
    const selectedCountry = isActiveFilter(filters.country) ? String(filters.country) : null;
    const random = createSeededRandom(buildReportSeed(startingMonth, endingMonth, filters));
    const totalEarnings = buildTotalEarnings(filters, random);
    const storeBreakdown = buildStoreBreakdown(totalEarnings, selectedStore, random);
    const months = buildMonthSeries(startingMonth, endingMonth);
    const multiRevenueData = buildMultiRevenueData(months, totalEarnings, storeBreakdown, random);

    return {
        country_wise_sales: buildCountrySales(totalEarnings, selectedCountry, random),
        top_5: buildTopFive(totalEarnings, random),
        multi_revenue_data: multiRevenueData,
        storewise_revenue: buildStorewiseRevenue(storeBreakdown),
    };
};

export default simulateMockEarningsData;
